import {
  STATIC_ASSETS_PATH,
  FULFILLMENT_METHOD_STH,
  FULFILLMENT_METHOD_BOPIS,
  FULFILLMENT_METHOD_BODFS
} from './product-add-on-constants';

export const buildImageURL = (imageName) => `${STATIC_ASSETS_PATH}${imageName}`;

const displayInstallationSku = ({ isInstallationSku, availableFulfillments, isTwoTileEnabled = false }) => {
  return isTwoTileEnabled ? isInstallationSku
    : (isInstallationSku && availableFulfillments.includes(FULFILLMENT_METHOD_STH));
};
const displayInStoreAssembly = ({ inStoreAssemblyAvailable, availableFulfillments, isTwoTileEnabled = false }) => {
  return isTwoTileEnabled ? inStoreAssemblyAvailable
    : (inStoreAssemblyAvailable
      && availableFulfillments.includes(FULFILLMENT_METHOD_BOPIS));
};

const displayBodfsStoreAssembly = ({
  bodfsAssemblyEligible,
  availableFulfillments,
  isTwoTileEnabled,
  bodfsGrillsAssemblyEnabled
}) => {
  return isTwoTileEnabled
  && bodfsAssemblyEligible
  && bodfsGrillsAssemblyEnabled
  && availableFulfillments.includes(FULFILLMENT_METHOD_BODFS);
};

export const displayAttachLabor = ({
  isInstallationSku,
  inStoreAssemblyAvailable,
  availableFulfillments,
  currentFulfillment,
  isTwoTileEnabled,
  // Flag from backend on if the item is eligible for BODFS assembly
  bodfsAssemblyEligible,
  // FS for BODFS Grill Assembly
  bodfsGrillsAssemblyEnabled
}) => {
  return (
    currentFulfillment && (
      displayInstallationSku({ isInstallationSku, availableFulfillments, isTwoTileEnabled })
      || displayInStoreAssembly({ inStoreAssemblyAvailable, availableFulfillments, isTwoTileEnabled })
      || displayBodfsStoreAssembly({
        bodfsAssemblyEligible,
        availableFulfillments,
        isTwoTileEnabled,
        bodfsGrillsAssemblyEnabled
      })
    )
  );
};